// extracted by mini-css-extract-plugin
module.exports = {"image":"bQ","image-placeholder":"bR","imagePlaceholder":"bR"};